import React from "react";
import { HardHat, ClipboardCheck, Zap, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Maîtrise d'Œuvre",
  description: "Pilotage complet de vos projets de construction et rénovation, de la conception à la réception des travaux.",
  icon: HardHat,
  link: "/ProjectManagementPage"
}, {
  title: "AMO Livraisons",
  description: "Assistance experte lors de la livraison de vos biens immobiliers pour garantir la conformité et la qualité.",
  icon: ClipboardCheck,
  link: "/OwnerAssistanceDeliveriesPage"
}, {
  title: "Audit Énergétique",
  description: "Analyse approfondie de la performance énergétique de vos bâtiments pour optimiser confort et économies.",
  icon: Zap,
  link: "/EnergyAuditPage"
}];
export default function NosServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}